import moment from "moment";
import SHA256 from "sha.js"; // Import sha.js
export const getFileTypeFromUrl = (url: string): string | null => {
    const urlWithoutQuery = url.split("?")[0];
    const parts = urlWithoutQuery.split(".");
    if (parts.length > 1) {
        return parts[parts.length - 1]; // Return the file extension
    }
    return null;
};

export const shortenUrl = async (longUrl: string): Promise<string> => {
    try {
        const endpoint = `https://tinyurl.com/api-create.php?url=${encodeURIComponent(longUrl)}`;
        const response = await fetch(endpoint);
        if (!response.ok) {
            console.log(response, 'Error while creating shorter url');
            return "";
        }
        const shortUrl = await response?.text();
        return shortUrl;
    } catch (err) {
        console.log(err);
        return longUrl;
    }
}

export const convertDateToLocalTime = (time: number | string, timeZone?: string) => {
    let date = moment.utc(time);
    if (timeZone) {
        date = date.tz(timeZone);
    } else {
        date = date.local();
    }

    return date.valueOf();
}

export async function fileToBinary(file: File): Promise<Uint8Array> {
    const buffer = await file.arrayBuffer();
    return new Uint8Array(buffer);
}

export const hashText = (text: string) => {
    return new SHA256.sha256().update(text).digest("hex");
};